export function isNode(node: any): boolean {
  return node && node.isNode;
}